import { useQuery } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import { deliveryAgencyKeys } from './keys';

import type {
  TypeGetDashboardDeliveryTrendParams,
  TypeGetDashboardDeliveryTrendResponse,
} from '~/types/delivery-agency.types';

/**
 * [배송 현황 대시보드] 배송 추이 조회 API
 */
const fetchDashboardDeliveryTrend = async (
  params: TypeGetDashboardDeliveryTrendParams
): Promise<TypeGetDashboardDeliveryTrendResponse> => {
  const { data } = await axiosInstance.get<TypeGetDashboardDeliveryTrendResponse>(
    API_ENDPOINT.DELIVERY_AGENCY.GET_DASHBOARD_DELIVERY_TREND,
    { params }
  );
  return data;
};

type UseGetDashboardDeliveryTrendQueryOptions = {
  params: TypeGetDashboardDeliveryTrendParams;
  enabled?: boolean;
};

/**
 * [배송 현황 대시보드] 배송 추이 조회 Query Hook
 */
export const useGetDashboardDeliveryTrendQuery = ({
  params,
  enabled = true,
}: UseGetDashboardDeliveryTrendQueryOptions) => {
  return useQuery({
    queryKey: deliveryAgencyKeys.dashboardDeliveryTrend(params),
    queryFn: () => fetchDashboardDeliveryTrend(params),
    enabled,
    staleTime: 0,
    gcTime: 1000 * 30,
  });
};
